import ActionAudienceOperationDataSource from "../data/source/ActionAudienceOperationDataSource";
import BaseDetailedAudienceOperation from "./BaseDetailedAudienceOperation";
class ActionDetailedAudienceOperation extends BaseDetailedAudienceOperation {
    constructor(response) {
        super(response);
        this.data_source = new ActionAudienceOperationDataSource(response.data_source);
    }
}
export default ActionDetailedAudienceOperation;
